module.exports = __webpack_public_path__ + "img/384.d29bc55a.png";